import React from 'react';
import Page from '../../layout/Page';
import Orders from './Orders';
import FulfilledOrders from './FulfilledOrders';

const Fulfillment = ({ ...props }) => {

    return (
        <Page
            title='Fulfillment'
            icon='scale'
            tabs
        >
            <Orders tab='Orders' />
            <FulfilledOrders tab='Fulfilled Orders' />
        </Page >
    );
}

export default Fulfillment;
